var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container fid-card" }, [
    _c("div", { staticClass: "col-xs-12" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v("Carte de fidélité " + _vm._s(_vm.card.cardno)),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-center" }, [
        _c("a", { attrs: { href: _vm.cardUrl(_vm.card) } }, [
          _vm._v("Lien direct de la carte"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-xs-12 text-center" },
      [_c("VueQr", { attrs: { size: 175, text: _vm.card.cardno } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("input", {
        staticClass: "form-control",
        attrs: { type: "text", placeholder: "", disabled: "" },
        domProps: { value: "Numéro de carte: " + _vm.card.cardno },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("input", {
        staticClass: "form-control",
        attrs: { type: "text", placeholder: "", disabled: "" },
        domProps: { value: "Solde: " + _vm.card.nbPoints + " points" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }